import React, { useMemo } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";

function ModaArticoliFilters({
  quickSearch,
  onQuickSearchChange,
  onQuickSearchSubmit,
  onResetFilters,
  onOpenAdvancedFilters,
  onOpenBulkAssign,
  onRefresh,
  onOpenFunctions,
  appliedFilters,
  mobile = false,
  onShowAssigned,
  onShowNeedTexts,
  onShowNeedImages,
  loading = false,
  canBulkAssign = false,
}) {
  const { buttonClassesWhite, buttonClassesGreen, buttonClassesRed } =
    stilePulsanti;

  const activeFiltersCount = useMemo(() => {
    if (!appliedFilters) {
      return 0;
    }
    return Object.values(appliedFilters).filter(
      (value) => value !== undefined && value !== null && String(value).trim()
    ).length;
  }, [appliedFilters]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onQuickSearchSubmit();
  };

  const renderAppliedFilters = () => {
    if (!appliedFilters || activeFiltersCount === 0) {
      return null;
    }
    return (
      <div className="mt2 flex flex-wrap items-center f7">
        {Object.entries(appliedFilters)
          .filter(
            ([, value]) =>
              value !== undefined &&
              value !== null &&
              String(value).trim().length > 0
          )
          .map(([key, value]) => (
            <span
              key={key}
              className="mr2 mb2 ph2 pv1 br-pill bg-washed-blue dark-blue"
            >
              {key}: <strong>{value}</strong>
            </span>
          ))}
      </div>
    );
  };

  return (
    <div className="cf">
      <div className="w-100">
        <form
          onSubmit={handleSubmit}
          className="flex flex-column flex-row-l items-start items-end-l"
        >
          <label className="db mb2 mb0-l w-100 w-50-l">
            <span className="db f6 ttu tracked gray">
              Ricerca tra i risultati (codice, descrizioni, brand...)
            </span>
            <div className="flex items-center">
              <input
                type="text"
                value={quickSearch}
                onChange={(event) => onQuickSearchChange(event.target.value)}
                placeholder="Digita e premi invio per filtrare"
                className="input-reset ba b--silver br2 pa2 flex-auto"
              />
              <button
                type="submit"
                className={`${buttonClassesGreen} ml2 mr2`}
                title="Applica la ricerca"
                disabled={loading}
              >
                Cerca
              </button>
              <button
                type="button"
                className={`${buttonClassesWhite} mr2`}
                onClick={onRefresh}
                disabled={loading}
              >
                Aggiorna
              </button>
              <div
                className="ml3 mr3"
                style={{
                  borderRight: "1px solid var(--colChiaro)",
                  minHeight: "32px",
                  alignSelf: "stretch",
                }}
              />
              <button
                type="button"
                className={`${buttonClassesWhite} mr2`}
                onClick={onOpenAdvancedFilters}
                disabled={loading}
              >
                {mobile ? "Filtri" : "Filtri avanzati"}
                {activeFiltersCount > 0 ? ` (${activeFiltersCount})` : ""}
              </button>
              {activeFiltersCount > 0 && (
                <button
                  type="button"
                  className={buttonClassesRed}
                  onClick={onResetFilters}
                  title="Rimuovi tutti i filtri"
                  disabled={loading}
                >
                  Pulisci filtri
                </button>
              )}
            </div>
          </label>
          <div className="flex items-start items-end-l mt3 mt0-l w-100 w-50-l justify-start justify-end-l">
            <button
              type="button"
              className={`${buttonClassesWhite} mr2`}
              onClick={onResetFilters}
              disabled={loading}
            >
              Tutti gli articoli
            </button>
            <button
              type="button"
              className={`${buttonClassesWhite} mr2`}
              onClick={onShowAssigned}
              disabled={loading}
            >
              Assegnati a me
            </button>
            <button
              type="button"
              className={`${buttonClassesWhite} mr2`}
              onClick={onShowNeedTexts}
              disabled={loading}
            >
              Da pubblicare
            </button>
            <button
              type="button"
              className={`${buttonClassesWhite} mr2`}
              onClick={onShowNeedImages}
              disabled={loading}
            >
              Immagini da fare
            </button>
            <div
              className="ml3 mr3"
              style={{
                borderRight: "1px solid var(--colChiaro)",
                minHeight: "32px",
                alignSelf: "stretch",
              }}
            />
            {canBulkAssign && (
              <button
                type="button"
                className={`${buttonClassesWhite} mr2`}
                onClick={onOpenBulkAssign}
                disabled={loading}
              >
                Assegna lavorazioni
              </button>
            )}
            {onOpenFunctions && (
              <button
                type="button"
                className={buttonClassesWhite}
                onClick={onOpenFunctions}
                disabled={loading}
              >
                Funzioni
              </button>
            )}
          </div>
        </form>
        {renderAppliedFilters()}
      </div>
    </div>
  );
}

export default ModaArticoliFilters;
